// extracted by mini-css-extract-plugin
export default {"imgContainer":"CM8CDJDQoZ_F7xYufSBi","img":"kgwd_cKCA4KBK6EF0PVU"};